(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6674],{

/***/ 96674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dialog; }
});

// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/reach-dialog.mjs + 49 modules
var reach_dialog = __webpack_require__(42128);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/dialog/Dialog.module.scss
var Dialog_module = __webpack_require__(58023);
var Dialog_module_default = /*#__PURE__*/__webpack_require__.n(Dialog_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/dialog/Dialog.js








var Dialog = function Dialog(_ref) {
  var showDialog = _ref.showDialog,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$main = _ref.main,
      main = _ref$main === void 0 ? null : _ref$main,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      _ref$dialogClassName = _ref.dialogClassName,
      dialogClassName = _ref$dialogClassName === void 0 ? null : _ref$dialogClassName,
      _ref$rootClassName = _ref.rootClassName,
      rootClassName = _ref$rootClassName === void 0 ? null : _ref$rootClassName,
      _ref$headerClassName = _ref.headerClassName,
      headerClassName = _ref$headerClassName === void 0 ? null : _ref$headerClassName,
      _ref$mainClassName = _ref.mainClassName,
      mainClassName = _ref$mainClassName === void 0 ? null : _ref$mainClassName,
      _ref$footerClassName = _ref.footerClassName,
      footerClassName = _ref$footerClassName === void 0 ? null : _ref$footerClassName,
      _ref$onDismiss = _ref.onDismiss,
      onDismiss = _ref$onDismiss === void 0 ? function () {} : _ref$onDismiss;
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(reach_dialog/* DialogOverlay */.t9, {
    isOpen: showDialog,
    "aria-label": undefined,
    className: (0,clsx_m/* default */.Z)((Dialog_module_default()).root, rootClassName),
    onDismiss: onDismiss,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(reach_dialog/* DialogContent */.cZ, {
      className: (0,clsx_m/* default */.Z)((Dialog_module_default()).dialog, dialogClassName, hasSmartBanner && (Dialog_module_default()).hasBanner),
      children: [header && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: (0,clsx_m/* default */.Z)((Dialog_module_default()).header, headerClassName),
        children: header
      }), main && /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
        className: (0,clsx_m/* default */.Z)((Dialog_module_default()).block, mainClassName),
        children: main
      }), footer && /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
        className: (0,clsx_m/* default */.Z)((Dialog_module_default()).footer, footerClassName),
        children: footer
      })]
    })
  });
};

/* harmony default export */ var dialog_Dialog = (Dialog);
;// CONCATENATED MODULE: ./components/dialog/index.js

/* harmony default export */ var dialog = (dialog_Dialog);

/***/ }),

/***/ 58023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialog_root___91eo","dialog":"Dialog_dialog__6d2KJ","header":"Dialog_header__mKiZ8","block":"Dialog_block__LGMvR","footer":"Dialog_footer__kv0TP","hasBanner":"Dialog_hasBanner__9LB2x","load":"Dialog_load__QFRzO"};

/***/ })

}]);